import type { Model, ShadyPinesModel } from '@shady-pines/db';

export type Cursor = string & {
  _cursor: 'Cursor';
};

export type Edge<T extends Record<string, unknown>> = {
  node: T;
  cursor: Cursor;
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor: Cursor | null;
};

export const isCollection = <T extends Record<string, unknown>>(
  key: string,
  value: unknown,
): value is Collection<T> => {
  if (!key.endsWith('Collection')) {
    return false;
  }

  if (typeof value !== 'object' || value === null) {
    return false;
  }

  if (!('edges' in value) || !Array.isArray(value.edges)) {
    return false;
  }

  return value.edges.every((edge) => 'node' in edge && edge.node !== undefined);
};

export type Collection<T extends Record<string, unknown>> = {
  edges: Edge<T>[];
  pageInfo: PageInfo;
};

export type CollectionResponse<T extends Record<string, unknown>, K extends string> = {
  [key in K]: Collection<T>;
};

export type QueryVariables<T extends Record<string, unknown>> = T & {
  first?: number;
  after?: string | null;
};

export type MutationResponse<T extends string, M extends ShadyPinesModel> = {
  [key in T]: {
    records: [Model<M>];
  };
};

export const StorageBucket = ['event-artwork', 'popups', 'show-artwork', 'bug-reports'] as const;
export type StorageBucket = (typeof StorageBucket)[number];
